module.exports = __webpack_public_path__ + "img/logo-vff.502ee1da.png";